export interface Message {
  message: string;
  unread: boolean;
  info?: boolean;
  warning?: boolean;
  success?: boolean;
  error?: boolean;
}

export interface State {
  messages: Message[];
}

export const initialState: State = {
  messages: [],
};
